module.exports = __webpack_public_path__ + "media/components/signup/static/cards-ec268987181d14aece3356a9a8397ddc.png";